import { Box, DataGrid, Empty, IconButton, Tooltip } from '@digibee/beehive-ui';
import { choose, otherwise, when } from '@digibee/control-statements';
import { EditPencil } from 'iconoir-react';
import { useTranslation } from 'react-i18next';

import MembersSidesheet from './components/MembersSidesheet';
import * as Elements from './Organization.elements';
import type { Props } from './Organization.enhancer';
import { OrganizationGroup } from '../../models/organization';

import theme from '~/common/styled/theme';

const Groups = ({ data, loading, openModal }: Props) => {
  const [t] = useTranslation();

  return (
    <>
      <Elements.Container>
        {choose(
          when(!data || !data.length, () => (
            <Empty
              illustration={theme.images.emptyStateList}
              title={t('label.organization_no_company_message') || ''}
              message={t('label.organization_no_company_support_message') || ''}
              buttonHide
            />
          )),
          otherwise(() => (
            <DataGrid<OrganizationGroup>
              loading={loading}
              data-testid='governance-organization-groups-list-table'
              data={data || []}
              isPagination
              manualPagination
              autoResetPage={false}
              showRowsPerPage={false}
              totalElements={1}
              pageSize={1}
              pageCount={1}
              page={0}
              columns={[
                {
                  id: 'name',
                  Header: t('scenes.groups.labels.name') as string,
                  accessor: 'name'
                },
                {
                  id: 'members',
                  Header: t('scenes.groups.labels.members') as string,
                  Cell: ({ row }: { row: { original: OrganizationGroup } }) => (
                    <Box>{row.original?.users?.length}</Box>
                  )
                },
                {
                  id: 'action',
                  Header: t('label.actions') as string,
                  Cell: ({ row }: { row: { original: OrganizationGroup } }) => (
                    <>
                      <Tooltip
                        align='center'
                        content={t('scenes.groups.actions.update')}
                        side='bottom'
                      >
                        <IconButton
                          onClick={() =>
                            openModal(
                              row.original?.users,
                              row.original?.name,
                              row.original?.realms
                            )
                          }
                          size='medium'
                          data-testid='groups-edit-button'
                        >
                          <EditPencil />
                        </IconButton>
                      </Tooltip>
                    </>
                  )
                }
              ]}
            />
          ))
        )}
      </Elements.Container>
      <MembersSidesheet />
    </>
  );
};

export default Groups;
